module.exports = __webpack_public_path__ + "media/images/pages/i-belong/primary_handbook-e4c257c3597de1ded77e964ab19793a6.svg";